import { createStore } from "vuex";
import {availableFinishes, productFamily} from "VueInterfaces/ProductFamilyInterface";

const catBrowseStore = createStore({
	state: {
		responseData: {} as productFamily,
		categorySlug: '' as string,
		categoryName: '' as string,
		categoryDescription: '' as string,
		groupBy: '' as string,
		language: '' as string,
		selectedFinish: {} as availableFinishes,
		showWholesale: false as boolean
	},
	mutations: {
		setResponseData(state, data) {
			state.responseData = data;
		},
		setCategorySlug(state, data) {
			state.categorySlug = data;
		},
		setCategoryName(state, data) {
			state.categoryName = data;
		},
		setCategoryDescription(state, data) {
			state.categoryDescription = data;
		},
		setLanguage(state, data) {
			state.language = data;
		},
		setSelectedFinish(state, data) {
			state.selectedFinish = data;
		},
		setGroupBy(state, data) {
			state.groupBy = data;
		},
		setShowWholesale(state, data) {
			state.showWholesale = data;
		}
	},
	getters: {
		responseData (state) {
			return state.responseData;
		},
		categorySlug(state) {
			return state.categorySlug;
		},
		categoryName(state) {
			return state.categoryName;
		},
		groupBy(state) {
			return state.groupBy
		},
		categoryDescription(state) {
			return state.categoryDescription;
		},
		language(state) {
			return state.language;
		},
		selectedFinish(state) {
			return state.selectedFinish;
		},
		showWholesale(state) {
			return state.showWholesale
		}
	},
	modules: {},
});

export default catBrowseStore;
